import { EventType, EventActionType, FixedEventType } from '../types';
import { SYSTEMS_NAMES } from '../enums';

export interface ITrackOptions {
  isPrefix?: boolean;
  data?: object;
  selectedSystems?: SYSTEMS_NAMES[];
}

export interface EventDataTrack {
  event_label?: string | string[] | object;
  [key: string]: unknown;
}

export interface ITrackNewAnalytics {
  eventName: EventType;
  eventAction?: EventActionType;
  eventData?: EventDataTrack | PurchaseData;
}

export interface PurchaseData {
  fieldsToBeDeleted?: string[];
  [key: string]: any;
}

export interface IPurchaseNew {
  eventName: 'purchase';
  data: PurchaseData;
}

export interface IPrepareTrackParams {
  eventName: string;
  eventAction?: EventActionType;
  eventData: object;
}

export enum EventTrigger {
  screenLoad = 'screen__load',
  click = 'click',
}

export enum EventTriggerFixed {
  deeplinkLoad = 'deeplink__load',
  profileUpdateSuccess = 'profile_update_success',
  profileUpdateError = 'profile_update_error',
  avatarUpdateSuccess = 'avatar_update_success',
  emailUpdateSuccess = 'email_update_success',
  passwordUpdateSuccess = 'password_update_success',
  accountDeleteSuccess = 'account_delete_success',
  subscriptionCancelSuccess = 'subscription_cancel_success',
  chatClick = 'chat__click',
  loginError = 'login_error',
  loginSuccess = 'login_success',
  cabinetSessionStarted = 'cabinet__session_started',
}

export interface IEventTrigger {
  event: EventTrigger;
  screenId: string;
}

export enum ElementEventAction {
  screen = 'screen',
  button = 'button',
  link = 'link',
  option = 'option',
  text = 'text',
  input = 'input',
  form = 'form',
  popup = 'popup',
  loader = 'loader',
  timer = 'timer',
  slider = 'slider',
  image = 'image',
  header = 'header',
  guide = 'guide',
  key = 'key',
}

export enum ActionEventAction {
  continue = 'continue',
  select = 'select',
  next = 'next',
  back = 'back',
  close = 'close',
  skip = 'skip',
  scroll = 'scroll',
  redirect = 'redirect',
  load = 'load',
  headerLogin = 'header_login',
  email = 'email',
  password = 'password',
  login = 'login',
  resetPassword = 'reset_password',
  sendPassword = 'send_password',
  contactUs = 'contact_us',
  resendPassword = 'resend_password',
  downloadApp = 'download_app',
  save = 'save',
  accountDelete = 'account_delete',
  takeQuiz = 'take_quiz',
  quizContinue = 'quiz_continue',
  cancelSubscription = 'cancel_subscription',
  download = 'download',
  app = 'app',
  guides = 'guides',
  courses = 'courses',
  accountSettings = 'account_settings',
  faq = 'faq',
  termsOfUse = 'terms_of_use',
  privacyPolicy = 'privacy_policy',
  refundPolicy = 'refund_policy',
  logOut = 'log_out',
  startStudying = 'start_studying',
}

export interface IEventAction {
  elementEvent: ElementEventAction;
  actionEvent: ActionEventAction;
}

export interface ITrackNew {
  eventData: IEventTrigger | FixedEventType | EventTriggerFixed | string;
  actionData?: IEventAction | null | string;
  data?: EventDataTrack | null;
}

export type GTMEvent = {
  name: string;
  type?: 'custom_event' | 'pageview_event';
  data?: EventDataTrack;
};
